import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import HumanAgentEntity, { HumanAgentStatus } from "../../../../domain/entities/human_agent.entity";
import di from "../../../../dependency_injection";
import QAAgentEntity from "../../../../domain/entities/qa_agent.entity";
import HostApi, { HostApiName } from "../../../settings/HostApi";

const updateHumanAgentApiImpl = async (agent: HumanAgentEntity): Promise<Either<ErrorEntity, HumanAgentEntity>> => {
    try {
        const relativeUrl = `/human-agent/${agent.id}`;
        const body = {
            "name": agent.name,
            "internal_id": agent.agentId,
            "is_active": agent.status == HumanAgentStatus.active,
        };
        await di.get<HostApi>(HostApiName).put(relativeUrl, body, {
            contentType: "application/json",
        });
        return right(agent);
    } catch (error) {
        return left(ErrorEntity.fromError(error));
    }
};

export default updateHumanAgentApiImpl;